// /* eslint-disable */

// // ─────────────────────────────────────────────────────────────────────────────
// // TYPES
// // ─────────────────────────────────────────────────────────────────────────────

// type PremiumRates = Record<string, number>;
// type PremiumTable = Record<string, any>;

// interface AgeCriteria {
// 	is_present?: boolean;
// 	use_age_bands: boolean;
// 	age_band_ranges: string[];
// 	use_specific_ages: boolean;
// 	specific_age_list: number[];
// }

// interface BenefitAmountTier {
// 	options: number[];
// 	age_criteria?: AgeCriteria;
// }

// interface PlanConfig {
// 	is_premium_depends_on_smoke: boolean;
// 	coverage_for: { is_present: boolean; options: string[] };
// 	pay_frequency: { is_present: boolean; options: string[] };
// 	coverage_volume: { is_present: boolean; options: string[] };
// 	benefit_amount: {
// 		is_present: boolean;
// 		options: number[];
// 		spouse?: BenefitAmountTier;
// 		child?: BenefitAmountTier;
// 		spouse_and_child?: BenefitAmountTier;
// 	};
// 	age_criteria: AgeCriteria;
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // CONSTANTS
// // ─────────────────────────────────────────────────────────────────────────────

// const TIER_PATTERNS = [
// 	"Employee Only",
// 	"Spouse Only",
// 	"Children Only",
// 	"Employee & Spouse",
// 	"Employee & Children",
// 	"Employee & Family",
// 	"Spouse & Children"
// ];

// const PAY_FREQUENCIES = ["WEEKLY", "MONTHLY", "BIWEEKLY", "SEMI-MONTHLY"];
// const SMOKER_KEYS = ["smoker", "non_smoker"];

// // ─────────────────────────────────────────────────────────────────────────────
// // HELPERS
// // ─────────────────────────────────────────────────────────────────────────────

// function isPayFrequency(cell: string): boolean {
// 	return PAY_FREQUENCIES.includes(cell.toUpperCase());
// }

// function isSmokerKey(cell: string): boolean {
// 	return SMOKER_KEYS.includes(cell.toLowerCase());
// }

// function isTier(cell: string): boolean {
// 	return TIER_PATTERNS.some((t) => t.toLowerCase() === cell.toLowerCase());
// }

// function isCarrierName(cell: string): boolean {
// 	return cell.toLowerCase().startsWith("carrier name");
// }

// function isBenefitAmountHeader(cell: string): boolean {
// 	return cell.toLowerCase() === "benefit amount";
// }

// function isNumeric(cell: string): boolean {
// 	return cell !== "" && !isNaN(Number(cell));
// }

// function isStructuralKeyword(cell: string): boolean {
// 	return (
// 		isCarrierName(cell) ||
// 		isSmokerKey(cell) ||
// 		isPayFrequency(cell) ||
// 		isTier(cell) ||
// 		cell.toLowerCase() === "age band" ||
// 		cell.toLowerCase() === "coverage_for" ||
// 		isBenefitAmountHeader(cell)
// 	);
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // DEEP MERGE — merges src into dst recursively
// // ─────────────────────────────────────────────────────────────────────────────

// function deepMerge(dst: PremiumTable, src: PremiumTable): void {
// 	for (const key of Object.keys(src)) {
// 		if (
// 			typeof src[key] === "object" &&
// 			src[key] !== null &&
// 			!Array.isArray(src[key]) &&
// 			typeof dst[key] === "object" &&
// 			dst[key] !== null
// 		) {
// 			deepMerge(dst[key], src[key]);
// 		} else {
// 			dst[key] = src[key];
// 		}
// 	}
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // LAYOUT DETECTION
// // ─────────────────────────────────────────────────────────────────────────────

// type SheetLayout =
// 	| "flat_table" // coverage_for | WEEKLY | MONTHLY
// 	| "multi_benefit_table" // 1220 | coverage_for | WEEKLY ...
// 	| "volume_tier_benefit" // smoker → volume → tiers side by side → benefit rows
// 	| "nested"; // smoker → WEEKLY → volume → tier → Age Band → data

// function detectLayout(rows: string[][]): SheetLayout {
// 	for (const row of rows) {
// 		const cells = row.map((c) => c.trim());
// 		const nonEmpty = cells.filter((c) => c !== "");
// 		console.log("this is the nonEmpty", nonEmpty);

// 		// "volume_tier_benefit": 2+ tier cells side by side in same row
// 		if (nonEmpty.length >= 2 && nonEmpty.every((c) => isTier(c))) {
// 			return "volume_tier_benefit";
// 		}

// 		// "multi_benefit_table": non-structural first cell followed by "coverage_for"
// 		if (
// 			nonEmpty.length >= 2 &&
// 			nonEmpty[1].toLowerCase() === "coverage_for" &&
// 			!isTier(nonEmpty[0]) &&
// 			!isSmokerKey(nonEmpty[0]) &&
// 			!isPayFrequency(nonEmpty[0]) &&
// 			!isCarrierName(nonEmpty[0])
// 		) {
// 			return "multi_benefit_table";
// 		}

// 		// "flat_table": first cell is "coverage_for" with freq columns
// 		if (cells[0].toLowerCase() === "coverage_for" && cells.slice(1).some((c) => isPayFrequency(c))) {
// 			return "flat_table";
// 		}
// 	}

// 	return "nested";
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // PARSER 1 — FLAT TABLE
// // ─────────────────────────────────────────────────────────────────────────────

// function parseFlatTable(rows: string[][], result: PremiumTable): void {
// 	let freqHeaders: string[] = [];
// 	let currentSmoker = "";

// 	for (const row of rows) {
// 		const firstCell = row[0]?.trim() ?? "";
// 		if (row.every((c) => c === "")) continue;
// 		if (isCarrierName(firstCell)) continue;

// 		if (isSmokerKey(firstCell)) {
// 			currentSmoker = firstCell.toLowerCase();
// 			continue;
// 		}

// 		if (firstCell.toLowerCase() === "coverage_for") {
// 			freqHeaders = row
// 				.slice(1)
// 				.map((c) => c.trim())
// 				.filter((c) => c !== "");
// 			continue;
// 		}

// 		if (isTier(firstCell) && freqHeaders.length > 0) {
// 			const values = row.slice(1);
// 			freqHeaders.forEach((freq, idx) => {
// 				const numValue = parseFloat(values[idx]);
// 				if (isNaN(numValue)) return;

// 				const path: string[] = [];
// 				if (currentSmoker) path.push(currentSmoker);
// 				path.push(firstCell, freq.toUpperCase());

// 				setDeepValue(result, path, numValue);
// 			});
// 		}
// 	}
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // PARSER 2 — MULTI BENEFIT TABLE
// // ─────────────────────────────────────────────────────────────────────────────

// interface BenefitBlock {
// 	benefit: string;
// 	tierCol: number;
// 	freqCols: { freq: string; colIndex: number }[];
// }

// function parseMultiBenefitTable(rows: string[][], result: PremiumTable): void {
// 	let blocks: BenefitBlock[] = [];
// 	let currentSmoker = "";
// 	let headerFound = false;

// 	for (let i = 0; i < rows.length; i++) {
// 		const cells = rows[i].map((c) => c.trim());
// 		const firstCell = cells[0];

// 		if (isCarrierName(firstCell)) continue;
// 		if (cells.every((c) => c === "")) continue;

// 		if (isSmokerKey(firstCell)) {
// 			currentSmoker = firstCell.toLowerCase();
// 			continue;
// 		}

// 		const nonEmpty = cells.filter((c) => c !== "");

// 		if (
// 			nonEmpty.length >= 2 &&
// 			nonEmpty[1].toLowerCase() === "coverage_for" &&
// 			!isTier(nonEmpty[0]) &&
// 			!isSmokerKey(nonEmpty[0]) &&
// 			!isPayFrequency(nonEmpty[0]) &&
// 			!isCarrierName(nonEmpty[0])
// 		) {
// 			blocks = [];
// 			headerFound = true;

// 			let col = 0;
// 			while (col < cells.length) {
// 				const cell = cells[col];
// 				if (
// 					cell !== "" &&
// 					!isTier(cell) &&
// 					!isPayFrequency(cell) &&
// 					!isSmokerKey(cell) &&
// 					!isCarrierName(cell) &&
// 					cell.toLowerCase() !== "coverage_for"
// 				) {
// 					const volume = cell;
// 					const tierCol = col + 1;
// 					const freqCols: { freq: string; colIndex: number }[] = [];

// 					let scan = col + 1;
// 					while (scan < cells.length) {
// 						const scanCell = cells[scan];
// 						if (
// 							scanCell !== "" &&
// 							!isPayFrequency(scanCell) &&
// 							scanCell.toLowerCase() !== "coverage_for" &&
// 							!isTier(scanCell) &&
// 							scan !== col
// 						) {
// 							break;
// 						}
// 						if (isPayFrequency(scanCell)) {
// 							freqCols.push({ freq: scanCell.toUpperCase(), colIndex: scan });
// 						}
// 						scan++;
// 					}

// 					blocks.push({ benefit: volume, tierCol, freqCols });
// 					col = scan;
// 				} else {
// 					col++;
// 				}
// 			}
// 			continue;
// 		}

// 		if (headerFound && blocks.length > 0) {
// 			for (const block of blocks) {
// 				const tierCell = cells[block.tierCol]?.trim() ?? "";
// 				if (!isTier(tierCell)) continue;

// 				block.freqCols.forEach(({ freq, colIndex }) => {
// 					const rawValue = cells[colIndex]?.trim();
// 					if (!rawValue) return;
// 					const numValue = parseFloat(rawValue);
// 					if (isNaN(numValue)) return;

// 					const path: string[] = [];
// 					if (currentSmoker) path.push(currentSmoker);
// 					path.push(block.benefit, tierCell, freq);

// 					setDeepValue(result, path, numValue);
// 				});
// 			}
// 		}
// 	}
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // PARSER 3 — VOLUME TIER BENEFIT
// // ─────────────────────────────────────────────────────────────────────────────

// interface TierBlock {
// 	tier: string;
// 	colStart: number;
// 	freqCols: { freq: string; colIndex: number }[];
// }

// function parseVolumeTierBenefit(rows: string[][], result: PremiumTable): void {
// 	let currentSmoker = "";
// 	let currentVolume = "";
// 	let tierBlocks: TierBlock[] = [];
// 	let awaitingData = false;

// 	for (let i = 0; i < rows.length; i++) {
// 		const cells = rows[i].map((c) => c.trim());
// 		const firstCell = cells[0];

// 		if (cells.every((c) => c === "")) {
// 			awaitingData = false;
// 			continue;
// 		}
// 		if (isCarrierName(firstCell)) continue;

// 		if (isSmokerKey(firstCell)) {
// 			currentSmoker = firstCell.toLowerCase();
// 			currentVolume = "";
// 			tierBlocks = [];
// 			awaitingData = false;
// 			continue;
// 		}

// 		if (isNumeric(firstCell) && cells.filter((c) => c !== "").length === 1) {
// 			currentVolume = firstCell;
// 			tierBlocks = [];
// 			awaitingData = false;
// 			continue;
// 		}

// 		const nonEmpty = cells.filter((c) => c !== "");
// 		if (nonEmpty.length >= 2 && nonEmpty.every((c) => isTier(c))) {
// 			tierBlocks = [];
// 			awaitingData = false;
// 			cells.forEach((cell, colIdx) => {
// 				if (isTier(cell)) {
// 					tierBlocks.push({ tier: cell, colStart: colIdx, freqCols: [] });
// 				}
// 			});
// 			continue;
// 		}

// 		if (tierBlocks.length > 0 && isBenefitAmountHeader(firstCell)) {
// 			tierBlocks.forEach((block, blockIdx) => {
// 				const nextBlockStart =
// 					blockIdx + 1 < tierBlocks.length ? tierBlocks[blockIdx + 1].colStart : cells.length;
// 				block.freqCols = [];
// 				for (let col = block.colStart + 1; col < nextBlockStart; col++) {
// 					if (isPayFrequency(cells[col])) {
// 						block.freqCols.push({ freq: cells[col].toUpperCase(), colIndex: col });
// 					}
// 				}
// 			});
// 			awaitingData = true;
// 			continue;
// 		}

// 		if (awaitingData && tierBlocks.length > 0) {
// 			const hasData = tierBlocks.some((block) => isNumeric(cells[block.colStart]));
// 			if (!hasData) continue;

// 			tierBlocks.forEach((block) => {
// 				const benefitCell = cells[block.colStart]?.trim();
// 				if (!benefitCell || !isNumeric(benefitCell)) return;

// 				block.freqCols.forEach(({ freq, colIndex }) => {
// 					const rawValue = cells[colIndex];
// 					if (!rawValue) return;
// 					const numValue = parseFloat(rawValue);
// 					if (isNaN(numValue)) return;

// 					const path: string[] = [];
// 					if (currentSmoker) path.push(currentSmoker);
// 					if (currentVolume) path.push(currentVolume);
// 					path.push(block.tier, benefitCell, freq);

// 					setDeepValue(result, path, numValue);
// 				});
// 			});
// 			continue;
// 		}
// 	}
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // PARSER 4 — NESTED
// //
// // Target output structure:
// //   [smoker →] volume → age → tier → [benefit →] payFreq = value
// //
// // Three fixes applied here:
// //
// // FIX 1 (isPayFrequency branch): Reset currentVolume + currentTier so volume
// //        labels in the new frequency block pass the currentTier==="" guard.
// //
// // FIX 2 (blank row handler): Reset currentTier + call resetModeFlags() so the
// //        next volume label isn't swallowed by a stale awaitingAgeBandRows=true.
// //
// // FIX 3 (Mode A data guard): Only fire when firstCell contains a digit so
// //        non-age-band labels like "Sdfds" fall through to volume detection.
// // ─────────────────────────────────────────────────────────────────────────────

// function parseNestedSheet(rows: string[][], result: PremiumTable): void {
// 	let currentSmoker = "";
// 	let currentPayFreq = "";
// 	let currentVolume = "";
// 	let currentTier = "";

// 	let ageBandFreqCols: { freq: string; colIndex: number }[] = [];
// 	let awaitingAgeBandRows = false;

// 	let benefitFreqCols: { freq: string; colIndex: number }[] = [];
// 	let awaitingBenefitRows = false;

// 	function resetModeFlags() {
// 		ageBandFreqCols = [];
// 		awaitingAgeBandRows = false;
// 		benefitFreqCols = [];
// 		awaitingBenefitRows = false;
// 	}

// 	for (let i = 0; i < rows.length; i++) {
// 		const row = rows[i];
// 		const firstCell = row[0]?.trim() ?? "";

// 		// ── FIX 2: Blank row = end of tier block.
// 		// Reset currentTier AND mode flags so the next volume label is correctly
// 		// detected and not swallowed by a stale awaitingAgeBandRows = true.
// 		if (row.every((c) => c === "")) {
// 			currentTier = "";
// 			resetModeFlags();
// 			continue;
// 		}

// 		if (isCarrierName(firstCell)) continue;

// 		// ── Smoker ──
// 		if (isSmokerKey(firstCell)) {
// 			currentSmoker = firstCell.toLowerCase();
// 			currentPayFreq = "";
// 			currentVolume = "";
// 			currentTier = "";
// 			resetModeFlags();
// 			continue;
// 		}

// 		// ── FIX 1: Pay Frequency ──
// 		// Reset currentVolume and currentTier so volume labels in the new
// 		// frequency block correctly pass the currentTier === "" guard.
// 		if (isPayFrequency(firstCell)) {
// 			currentPayFreq = firstCell.toUpperCase();
// 			currentVolume = "";
// 			currentTier = "";
// 			resetModeFlags();
// 			continue;
// 		}

// 		// ── Tier ──
// 		if (isTier(firstCell)) {
// 			currentTier = firstCell;
// 			resetModeFlags();
// 			continue;
// 		}

// 		// ── Mode A trigger: "Age Band" header row ──
// 		if (firstCell.toLowerCase() === "age band") {
// 			ageBandFreqCols = [];
// 			row.slice(1).forEach((cell, idx) => {
// 				const c = cell.trim();
// 				if (c !== "") {
// 					ageBandFreqCols.push({ freq: c, colIndex: idx + 1 });
// 				}
// 			});
// 			awaitingAgeBandRows = true;
// 			awaitingBenefitRows = false;
// 			benefitFreqCols = [];
// 			continue;
// 		}

// 		// ── Mode B trigger: "benefit amount" header row ──
// 		if (isBenefitAmountHeader(firstCell)) {
// 			benefitFreqCols = [];
// 			row.slice(1).forEach((cell, idx) => {
// 				const c = cell.trim();
// 				if (isPayFrequency(c)) {
// 					benefitFreqCols.push({ freq: c.toUpperCase(), colIndex: idx + 1 });
// 				}
// 			});
// 			awaitingBenefitRows = true;
// 			awaitingAgeBandRows = false;
// 			ageBandFreqCols = [];
// 			continue;
// 		}

// 		// ── Mode A data row ──
// 		// FIX 3: /\d/.test(firstCell) ensures only real age-band values (e.g.
// 		// "18-69", "70-78") are processed here. Non-digit volume labels like
// 		// "Sdfds" fall through to volume detection at the bottom.
// 		if (awaitingAgeBandRows && firstCell !== "" && ageBandFreqCols.length > 0 && /\d/.test(firstCell)) {
// 			const ageBand = firstCell;

// 			ageBandFreqCols.forEach(({ freq: colHeader, colIndex }) => {
// 				const rawValue = row[colIndex]?.trim();
// 				if (!rawValue) return;
// 				const numValue = parseFloat(rawValue);
// 				if (isNaN(numValue)) return;

// 				const path: string[] = [];
// 				if (currentSmoker) path.push(currentSmoker);
// 				if (currentVolume) path.push(currentVolume);
// 				path.push(ageBand);
// 				if (currentTier) path.push(currentTier);

// 				if (isPayFrequency(colHeader)) {
// 					path.push(colHeader.toUpperCase());
// 				} else {
// 					path.push(colHeader);
// 					if (currentPayFreq) path.push(currentPayFreq);
// 				}

// 				setDeepValue(result, path, numValue);
// 			});
// 			continue;
// 		}

// 		// ── Mode B data row ──
// 		if (awaitingBenefitRows && firstCell !== "" && isNumeric(firstCell) && benefitFreqCols.length > 0) {
// 			const benefit = firstCell;

// 			benefitFreqCols.forEach(({ freq, colIndex }) => {
// 				const rawValue = row[colIndex]?.trim();
// 				if (!rawValue) return;
// 				const numValue = parseFloat(rawValue);
// 				if (isNaN(numValue)) return;

// 				const path: string[] = [];
// 				if (currentSmoker) path.push(currentSmoker);
// 				if (currentVolume) path.push(currentVolume);
// 				if (currentTier) path.push(currentTier);
// 				path.push(benefit, freq);

// 				setDeepValue(result, path, numValue);
// 			});
// 			continue;
// 		}

// 		// ── Volume label: non-structural, non-numeric text before any tier ──
// 		if (firstCell !== "" && !isStructuralKeyword(firstCell) && !isNumeric(firstCell) && currentTier === "") {
// 			currentVolume = firstCell;
// 			resetModeFlags();
// 			continue;
// 		}
// 	}
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SHARED UTILITY — write a value at a deep path
// // ─────────────────────────────────────────────────────────────────────────────

// function setDeepValue(obj: PremiumTable, path: string[], value: number): void {
// 	let node = obj;
// 	for (let d = 0; d < path.length - 1; d++) {
// 		if (!node[path[d]]) node[path[d]] = {};
// 		node = node[path[d]];
// 	}
// 	node[path[path.length - 1]] = value;
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // SHEET ROUTER
// // ─────────────────────────────────────────────────────────────────────────────

// function parseSheetIntoResult(rows: string[][], result: PremiumTable): void {
// 	const layout = detectLayout(rows);
// 	console.log("Detected layout:", layout);

// 	switch (layout) {
// 		case "flat_table":
// 			parseFlatTable(rows, result);
// 			break;
// 		case "multi_benefit_table":
// 			parseMultiBenefitTable(rows, result);
// 			break;
// 		case "volume_tier_benefit":
// 			parseVolumeTierBenefit(rows, result);
// 			break;
// 		default:
// 			parseNestedSheet(rows, result);
// 			break;
// 	}
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN ENTRY — parse all sheets, store each under its sheet name
// // ─────────────────────────────────────────────────────────────────────────────

// export function parseCSVSheetsToJSON(csvText: string): PremiumTable {
// 	const result: PremiumTable = {};

// 	const headerRegex = /SHEET\s+\d+:\s*(\S+)/gi;
// 	const headers: { name: string; contentStart: number; headerStart: number }[] = [];
// 	let match: RegExpExecArray | null;

// 	while ((match = headerRegex.exec(csvText)) !== null) {
// 		headers.push({
// 			name: match[1],
// 			headerStart: match.index,
// 			contentStart: match.index + match[0].length
// 		});
// 	}

// 	for (let i = 0; i < headers.length; i++) {
// 		const { name, contentStart } = headers[i];
// 		const contentEnd = i + 1 < headers.length ? headers[i + 1].headerStart : csvText.length;
// 		const block = csvText.slice(contentStart, contentEnd);

// 		const rows = block.split("\n").map((line) => line.split(",").map((cell) => cell.trim()));

// 		const sheetResult: PremiumTable = {};
// 		parseSheetIntoResult(rows, sheetResult);
// 		console.log("this is the sheet result", sheetResult);

// 		if (result[name]) {
// 			deepMerge(result[name], sheetResult);
// 		} else {
// 			result[name] = sheetResult;
// 		}
// 	}

// 	console.log("Final parsed JSON:", JSON.stringify(result, null, 2));
// 	return result;
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // PREMIUM STRUCTURE BUILDER
// // ─────────────────────────────────────────────────────────────────────────────

// function resolveTierKey(tier: string): "spouse" | "child" | "spouse_and_child" | null {
// 	const t = tier.toLowerCase();
// 	if (t.includes("spouse") && (t.includes("child") || t.includes("children"))) return "spouse_and_child";
// 	if (t.includes("spouse")) return "spouse";
// 	if (t.includes("child") || t.includes("children")) return "child";
// 	return null;
// }

// function resolveTierBenefitOptions(tier: string, plan: any): number[] | null {
// 	if (!plan.benefit_amount?.is_present) return null;
// 	const tierKey = resolveTierKey(tier);
// 	if (tierKey && plan.benefit_amount[tierKey]?.options?.length) return plan.benefit_amount[tierKey].options;
// 	if (plan.benefit_amount.options?.length) return plan.benefit_amount.options;
// 	return null;
// }

// function resolveTierAgeBands(tier: string, plan: any): string[] | null {
// 	const tierKey = resolveTierKey(tier);
// 	if (tierKey) {
// 		const tierAC = plan.benefit_amount?.[tierKey]?.age_criteria;
// 		if (tierAC?.use_age_bands && tierAC.age_band_ranges?.length) return tierAC.age_band_ranges;
// 		if (tierAC?.use_specific_ages && tierAC.specific_age_list?.length) return tierAC.specific_age_list.map(String);
// 	}
// 	const ac = plan.age_criteria;
// 	if (!ac) return null;
// 	if (ac.use_age_bands && ac.age_band_ranges?.length) return ac.age_band_ranges;
// 	if (ac.use_specific_ages && ac.specific_age_list?.length) return ac.specific_age_list.map(String);
// 	return null;
// }

// function setDeep(obj: PremiumTable, keys: string[], value: any): void {
// 	let cur = obj;
// 	for (let i = 0; i < keys.length - 1; i++) {
// 		if (!cur[keys[i]]) cur[keys[i]] = {};
// 		cur = cur[keys[i]];
// 	}
// 	cur[keys[keys.length - 1]] = value;
// }

// export function buildPremiumStructure(plan: any): PremiumTable {
// 	const result: PremiumTable = {};
// 	if (!plan) return result;

// 	const coverageTiers =
// 		plan.coverage_for?.is_present && plan.coverage_for?.options?.length ? plan.coverage_for.options : [];
// 	if (!coverageTiers.length) return result;

// 	const smokerKeys: string[] = plan.is_premium_depends_on_smoke ? ["smoker", "non_smoker"] : [];

// 	const payFreqs: string[] =
// 		plan.pay_frequency?.is_present && plan.pay_frequency?.options?.length ? plan.pay_frequency.options : [];

// 	const volumes: string[] =
// 		plan.coverage_volume?.is_present && plan.coverage_volume?.options?.length ? plan.coverage_volume.options : [];

// 	const smokerDim = smokerKeys.length ? smokerKeys : [""];
// 	const volumeDim = volumes.length ? volumes : [""];

// 	for (const smoker of smokerDim) {
// 		for (const volume of volumeDim) {
// 			for (const tier of coverageTiers) {
// 				const ageBands = resolveTierAgeBands(tier, plan);
// 				const benefitOptions = resolveTierBenefitOptions(tier, plan);

// 				const prefix: string[] = [];
// 				if (smoker) prefix.push(smoker);
// 				if (volume) prefix.push(volume);

// 				if (ageBands?.length) {
// 					if (benefitOptions?.length) {
// 						for (const age of ageBands) {
// 							for (const ben of benefitOptions) {
// 								if (payFreqs.length) {
// 									for (const freq of payFreqs) {
// 										setDeep(result, [...prefix, age, tier, String(ben), freq], 0);
// 									}
// 								} else {
// 									setDeep(result, [...prefix, age, tier, String(ben)], 0);
// 								}
// 							}
// 						}
// 					} else {
// 						for (const age of ageBands) {
// 							if (payFreqs.length) {
// 								for (const freq of payFreqs) {
// 									setDeep(result, [...prefix, age, tier, freq], 0);
// 								}
// 							} else {
// 								setDeep(result, [...prefix, age, tier], 0);
// 							}
// 						}
// 					}
// 				} else {
// 					if (benefitOptions?.length) {
// 						for (const ben of benefitOptions) {
// 							if (payFreqs.length) {
// 								for (const freq of payFreqs) {
// 									setDeep(result, [...prefix, tier, String(ben), freq], 0);
// 								}
// 							} else {
// 								setDeep(result, [...prefix, tier, String(ben)], 0);
// 							}
// 						}
// 					} else {
// 						if (payFreqs.length) {
// 							for (const freq of payFreqs) {
// 								setDeep(result, [...prefix, tier, freq], 0);
// 							}
// 						} else {
// 							setDeep(result, [...prefix, tier], 0);
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}

// 	console.log("Premium structure:", JSON.stringify(result, null, 2));
// 	return result;
// }

/* eslint-disable */

// ─────────────────────────────────────────────────────────────────────────────
// TYPES
// ─────────────────────────────────────────────────────────────────────────────

type PremiumRates = Record<string, number>;
type PremiumTable = Record<string, any>;

interface AgeCriteria {
	is_present?: boolean;
	use_age_bands: boolean;
	age_band_ranges: string[];
	use_specific_ages: boolean;
	specific_age_list: number[];
}

interface BenefitAmountTier {
	options: number[];
	age_criteria?: AgeCriteria;
}

interface PlanConfig {
	is_premium_depends_on_smoke: boolean;
	coverage_for: { is_present: boolean; options: string[] };
	pay_frequency: { is_present: boolean; options: string[] };
	coverage_volume: { is_present: boolean; options: string[] };
	benefit_amount: {
		is_present: boolean;
		options: number[];
		spouse?: BenefitAmountTier;
		child?: BenefitAmountTier;
		spouse_and_child?: BenefitAmountTier;
	};
	age_criteria: AgeCriteria;
}

// ─────────────────────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────────────────────

const TIER_PATTERNS = [
	"Employee Only",
	"Spouse Only",
	"Children Only",
	"Employee & Spouse",
	"Employee & Children",
	"Employee & Family",
	"Spouse & Children"
];

const PAY_FREQUENCIES = ["WEEKLY", "MONTHLY", "BIWEEKLY", "SEMI-MONTHLY"];
const SMOKER_KEYS = ["smoker", "non_smoker"];

// ─────────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────────

function isPayFrequency(cell: string): boolean {
	return PAY_FREQUENCIES.includes(cell.toUpperCase());
}

function isSmokerKey(cell: string): boolean {
	return SMOKER_KEYS.includes(cell.toLowerCase());
}

function isTier(cell: string): boolean {
	return TIER_PATTERNS.some((t) => t.toLowerCase() === cell.toLowerCase());
}

function isCarrierName(cell: string): boolean {
	return cell.toLowerCase().startsWith("carrier name");
}

function isBenefitAmountHeader(cell: string): boolean {
	return cell.toLowerCase() === "benefit amount";
}

function isNumeric(cell: string): boolean {
	return cell !== "" && !isNaN(Number(cell));
}

function isStructuralKeyword(cell: string): boolean {
	return (
		isCarrierName(cell) ||
		isSmokerKey(cell) ||
		isPayFrequency(cell) ||
		isTier(cell) ||
		cell.toLowerCase() === "age band" ||
		cell.toLowerCase() === "coverage_for" ||
		isBenefitAmountHeader(cell)
	);
}

// ─────────────────────────────────────────────────────────────────────────────
// DEEP MERGE — merges src into dst recursively
// ─────────────────────────────────────────────────────────────────────────────

function deepMerge(dst: PremiumTable, src: PremiumTable): void {
	for (const key of Object.keys(src)) {
		if (
			typeof src[key] === "object" &&
			src[key] !== null &&
			!Array.isArray(src[key]) &&
			typeof dst[key] === "object" &&
			dst[key] !== null
		) {
			deepMerge(dst[key], src[key]);
		} else {
			dst[key] = src[key];
		}
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// LAYOUT DETECTION
// ─────────────────────────────────────────────────────────────────────────────

type SheetLayout =
	| "flat_table" // coverage_for | WEEKLY | MONTHLY
	| "multi_benefit_table" // 1220 | coverage_for | WEEKLY ...
	| "volume_tier_benefit"
	| "age_band_tier_benefit" // smoker → volume → tiers side by side → benefit rows
	| "nested"; // smoker → WEEKLY → volume → tier → Age Band → data

function detectLayout(rows: string[][]): SheetLayout {
	// "age_band_tier_benefit": row has 2+ tiers with "Age Band" in next non-empty row
	for (let i = 0; i < rows.length; i++) {
		const cells = rows[i].map((c) => c.trim());
		const nonEmpty = cells.filter((c) => c !== "");

		const tierCells = nonEmpty.filter((c) => isTier(c));
		if (tierCells.length >= 2 && tierCells.length === nonEmpty.length) {
			// look ahead for "Age Band" row
			for (let j = i + 1; j < rows.length; j++) {
				const nextNonEmpty = rows[j].map((c) => c.trim()).filter((c) => c !== "");
				if (nextNonEmpty.length === 0) continue;
				if (nextNonEmpty[0].toLowerCase() === "age band") {
					return "age_band_tier_benefit";
				}
				break;
			}
		}
	}
	for (const row of rows) {
		const cells = row.map((c) => c.trim());
		const nonEmpty = cells.filter((c) => c !== "");
		console.log("this is the nonEmpty", nonEmpty);

		// "volume_tier_benefit": 2+ tier cells side by side in same row
		if (nonEmpty.length >= 2 && nonEmpty.every((c) => isTier(c))) {
			return "volume_tier_benefit";
		}

		// "multi_benefit_table": non-structural first cell followed by "coverage_for"
		if (
			nonEmpty.length >= 2 &&
			nonEmpty[1].toLowerCase() === "coverage_for" &&
			!isTier(nonEmpty[0]) &&
			!isSmokerKey(nonEmpty[0]) &&
			!isPayFrequency(nonEmpty[0]) &&
			!isCarrierName(nonEmpty[0])
		) {
			return "multi_benefit_table";
		}

		// "flat_table": first cell is "coverage_for" with freq columns
		if (cells[0].toLowerCase() === "coverage_for" && cells.slice(1).some((c) => isPayFrequency(c))) {
			return "flat_table";
		}
	}

	return "nested";
}

// ─────────────────────────────────────────────────────────────────────────────
// PARSER 1 — FLAT TABLE
// coverage_for | WEEKLY | MONTHLY
// Employee Only |  20   |   30
// Output: [smoker →] tier → WEEKLY = 20
// ─────────────────────────────────────────────────────────────────────────────
function parseAgeBandTierBenefit(rows: string[][], result: PremiumTable): void {
	let currentSmoker = "";
	let currentVolume = "";
	let tierBlocks: TierBlock[] = [];
	let awaitingData = false;

	for (let i = 0; i < rows.length; i++) {
		const cells = rows[i].map((c) => c.trim());
		const firstCell = cells[0];

		if (cells.every((c) => c === "")) {
			awaitingData = false;
			continue;
		}
		if (isCarrierName(firstCell)) continue;

		// ── Smoker ──
		if (isSmokerKey(firstCell)) {
			currentSmoker = firstCell.toLowerCase();
			currentVolume = "";
			tierBlocks = [];
			awaitingData = false;
			continue;
		}

		const nonEmpty = cells.filter((c) => c !== "");

		// ── Volume label: single non-structural, non-tier cell ──
		if (nonEmpty.length === 1 && !isStructuralKeyword(firstCell) && !isTier(firstCell)) {
			currentVolume = firstCell;
			tierBlocks = [];
			awaitingData = false;
			continue;
		}

		// ── Tier header row: 2+ tiers side by side ──
		const tierCells = nonEmpty.filter((c) => isTier(c));
		if (tierCells.length >= 2 && tierCells.length === nonEmpty.length) {
			tierBlocks = [];
			awaitingData = false;
			cells.forEach((cell, colIdx) => {
				if (isTier(cell)) {
					tierBlocks.push({ tier: cell, colStart: colIdx, freqCols: [] });
				}
			});
			continue;
		}

		// ── "Age Band" header row: scan freq cols for each tier block ──
		if (tierBlocks.length > 0 && (firstCell.toLowerCase() === "age band" || firstCell.toLowerCase() === "age")) {
			tierBlocks.forEach((block, blockIdx) => {
				const nextBlockStart =
					blockIdx + 1 < tierBlocks.length ? tierBlocks[blockIdx + 1].colStart : cells.length;
				block.freqCols = [];
				for (let col = block.colStart + 1; col < nextBlockStart; col++) {
					if (isPayFrequency(cells[col])) {
						block.freqCols.push({ freq: cells[col].toUpperCase(), colIndex: col });
					}
				}
			});
			awaitingData = true;
			continue;
		}

		// ── Data rows: age band + values ──
		if (awaitingData && tierBlocks.length > 0 && firstCell !== "" && /\d/.test(firstCell)) {
			tierBlocks.forEach((block) => {
				const ageBandCell = cells[block.colStart]?.trim();
				if (!ageBandCell || !/\d/.test(ageBandCell)) return;

				block.freqCols.forEach(({ freq, colIndex }) => {
					const rawValue = cells[colIndex];
					if (!rawValue) return;
					const numValue = parseFloat(rawValue);
					if (isNaN(numValue)) return;

					const path: string[] = [];
					if (currentSmoker) path.push(currentSmoker);
					if (currentVolume) path.push(currentVolume);
					path.push(ageBandCell); // age
					path.push(block.tier, freq); // tier → freq

					setDeepValue(result, path, numValue);
				});
			});
			continue;
		}
	}
}
function parseFlatTable(rows: string[][], result: PremiumTable): void {
	let freqHeaders: string[] = [];
	let currentSmoker = "";

	for (const row of rows) {
		const firstCell = row[0]?.trim() ?? "";
		if (row.every((c) => c === "")) continue;
		if (isCarrierName(firstCell)) continue;

		if (isSmokerKey(firstCell)) {
			currentSmoker = firstCell.toLowerCase();
			continue;
		}

		if (firstCell.toLowerCase() === "coverage_for") {
			freqHeaders = row
				.slice(1)
				.map((c) => c.trim())
				.filter((c) => c !== "");
			continue;
		}

		if (isTier(firstCell) && freqHeaders.length > 0) {
			const values = row.slice(1);
			freqHeaders.forEach((freq, idx) => {
				const numValue = parseFloat(values[idx]);
				if (isNaN(numValue)) return;

				const path: string[] = [];
				if (currentSmoker) path.push(currentSmoker);
				path.push(firstCell, freq.toUpperCase());

				setDeepValue(result, path, numValue);
			});
		}
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// PARSER 2 — MULTI BENEFIT TABLE
// 1220 | coverage_for | WEEKLY | MONTHLY | | 2500 | coverage_for | WEEKLY
//      | Employee Only|   10   |   20    | |      | Employee Only|   30
// Output: [smoker →] benefit → tier → WEEKLY = 10
// ─────────────────────────────────────────────────────────────────────────────

interface BenefitBlock {
	benefit: string;
	tierCol: number;
	freqCols: { freq: string; colIndex: number }[];
}

function parseMultiBenefitTable(rows: string[][], result: PremiumTable): void {
	let blocks: BenefitBlock[] = [];
	let currentSmoker = "";
	let headerFound = false;

	for (let i = 0; i < rows.length; i++) {
		const cells = rows[i].map((c) => c.trim());
		const firstCell = cells[0];

		if (isCarrierName(firstCell)) continue;
		if (cells.every((c) => c === "")) continue;

		if (isSmokerKey(firstCell)) {
			currentSmoker = firstCell.toLowerCase();
			continue;
		}

		const nonEmpty = cells.filter((c) => c !== "");

		if (
			nonEmpty.length >= 2 &&
			nonEmpty[1].toLowerCase() === "coverage_for" &&
			!isTier(nonEmpty[0]) &&
			!isSmokerKey(nonEmpty[0]) &&
			!isPayFrequency(nonEmpty[0]) &&
			!isCarrierName(nonEmpty[0])
		) {
			blocks = [];
			headerFound = true;

			let col = 0;
			while (col < cells.length) {
				const cell = cells[col];
				if (
					cell !== "" &&
					!isTier(cell) &&
					!isPayFrequency(cell) &&
					!isSmokerKey(cell) &&
					!isCarrierName(cell) &&
					cell.toLowerCase() !== "coverage_for"
				) {
					const volume = cell;
					const tierCol = col + 1;
					const freqCols: { freq: string; colIndex: number }[] = [];

					let scan = col + 1;
					while (scan < cells.length) {
						const scanCell = cells[scan];
						if (
							scanCell !== "" &&
							!isPayFrequency(scanCell) &&
							scanCell.toLowerCase() !== "coverage_for" &&
							!isTier(scanCell) &&
							scan !== col
						) {
							break;
						}
						if (isPayFrequency(scanCell)) {
							freqCols.push({ freq: scanCell.toUpperCase(), colIndex: scan });
						}
						scan++;
					}

					blocks.push({ benefit: volume, tierCol, freqCols });
					col = scan;
				} else {
					col++;
				}
			}
			continue;
		}

		if (headerFound && blocks.length > 0) {
			for (const block of blocks) {
				const tierCell = cells[block.tierCol]?.trim() ?? "";
				if (!isTier(tierCell)) continue;

				block.freqCols.forEach(({ freq, colIndex }) => {
					const rawValue = cells[colIndex]?.trim();
					if (!rawValue) return;
					const numValue = parseFloat(rawValue);
					if (isNaN(numValue)) return;

					const path: string[] = [];
					if (currentSmoker) path.push(currentSmoker);
					path.push(block.benefit, tierCell, freq);

					setDeepValue(result, path, numValue);
				});
			}
		}
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// PARSER 3 — VOLUME TIER BENEFIT
//
// Handles sheets where tiers appear side-by-side (or alone) in a row, followed
// by a "benefit Amount" header row, then data rows with benefit amounts.
//
// Output: [smoker →] volume → tier → benefit → payFreq = value
//
// FIX A: Volume labels are now detected by "single non-structural, non-tier
//        cell on its own row" — works for both numeric AND text volumes.
//
// FIX B: A single tier on its own row (e.g. "Spouse & Children" alone) is now
//        accepted — changed nonEmpty.length >= 2 to >= 1.
// ─────────────────────────────────────────────────────────────────────────────

interface TierBlock {
	tier: string;
	colStart: number;
	freqCols: { freq: string; colIndex: number }[];
}

function parseVolumeTierBenefit(rows: string[][], result: PremiumTable): void {
	let currentSmoker = "";
	let currentVolume = "";
	let tierBlocks: TierBlock[] = [];
	let awaitingData = false;

	for (let i = 0; i < rows.length; i++) {
		const cells = rows[i].map((c) => c.trim());
		const firstCell = cells[0];

		if (cells.every((c) => c === "")) {
			awaitingData = false;
			continue;
		}
		if (isCarrierName(firstCell)) continue;

		// ── Smoker ──
		if (isSmokerKey(firstCell)) {
			currentSmoker = firstCell.toLowerCase();
			currentVolume = "";
			tierBlocks = [];
			awaitingData = false;
			continue;
		}

		const nonEmpty = cells.filter((c) => c !== "");

		// ── FIX A: Volume label — single cell on its own row that is not a
		// structural keyword and not a tier. Handles both numeric ("1000") and
		// text ("Dsfds") volume labels.
		if (nonEmpty.length === 1 && !isStructuralKeyword(firstCell) && !isTier(firstCell)) {
			currentVolume = firstCell;
			tierBlocks = [];
			awaitingData = false;
			continue;
		}

		// ── FIX B: Tier header row — 1 or more tier cells (side-by-side or alone).
		// Changed from >= 2 to >= 1 so a solo tier like "Spouse & Children" is
		// picked up correctly.
		if (nonEmpty.length >= 1 && nonEmpty.every((c) => isTier(c))) {
			tierBlocks = [];
			awaitingData = false;
			cells.forEach((cell, colIdx) => {
				if (isTier(cell)) {
					tierBlocks.push({ tier: cell, colStart: colIdx, freqCols: [] });
				}
			});
			continue;
		}

		// ── "benefit amount" header — scan each tier block for freq columns ──
		if (tierBlocks.length > 0 && isBenefitAmountHeader(firstCell)) {
			tierBlocks.forEach((block, blockIdx) => {
				const nextBlockStart =
					blockIdx + 1 < tierBlocks.length ? tierBlocks[blockIdx + 1].colStart : cells.length;
				block.freqCols = [];
				for (let col = block.colStart + 1; col < nextBlockStart; col++) {
					if (isPayFrequency(cells[col])) {
						block.freqCols.push({ freq: cells[col].toUpperCase(), colIndex: col });
					}
				}
			});
			awaitingData = true;
			continue;
		}

		// ── Data rows ──
		if (awaitingData && tierBlocks.length > 0) {
			const hasData = tierBlocks.some((block) => isNumeric(cells[block.colStart]));
			if (!hasData) continue;

			tierBlocks.forEach((block) => {
				const benefitCell = cells[block.colStart]?.trim();
				if (!benefitCell || !isNumeric(benefitCell)) return;

				block.freqCols.forEach(({ freq, colIndex }) => {
					const rawValue = cells[colIndex];
					if (!rawValue) return;
					const numValue = parseFloat(rawValue);
					if (isNaN(numValue)) return;

					const path: string[] = [];
					if (currentSmoker) path.push(currentSmoker);
					if (currentVolume) path.push(currentVolume);
					path.push(block.tier, benefitCell, freq);

					setDeepValue(result, path, numValue);
				});
			});
			continue;
		}
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// PARSER 4 — NESTED
//
// Target output structure:
//   [smoker →] volume → age → tier → [benefit →] payFreq = value
//
// FIX 1 (isPayFrequency branch): Reset currentVolume + currentTier so volume
//        labels in the new frequency block pass the currentTier==="" guard.
//
// FIX 2 (blank row handler): Reset currentTier + call resetModeFlags() so the
//        next volume label isn't swallowed by a stale awaitingAgeBandRows=true.
//
// FIX 3 (Mode A data guard): Only fire when firstCell contains a digit so
//        non-age-band labels like "Sdfds" fall through to volume detection.
// ─────────────────────────────────────────────────────────────────────────────

function parseNestedSheet(rows: string[][], result: PremiumTable): void {
	let currentSmoker = "";
	let currentPayFreq = "";
	let currentVolume = "";
	let currentTier = "";

	let ageBandFreqCols: { freq: string; colIndex: number }[] = [];
	let awaitingAgeBandRows = false;

	let benefitFreqCols: { freq: string; colIndex: number }[] = [];
	let awaitingBenefitRows = false;

	function resetModeFlags() {
		ageBandFreqCols = [];
		awaitingAgeBandRows = false;
		benefitFreqCols = [];
		awaitingBenefitRows = false;
	}

	for (let i = 0; i < rows.length; i++) {
		const row = rows[i];
		const firstCell = row[0]?.trim() ?? "";

		// ── FIX 2: Blank row = end of tier block.
		// Reset currentTier AND mode flags so the next volume label is correctly
		// detected and not swallowed by a stale awaitingAgeBandRows = true.
		if (row.every((c) => c === "")) {
			currentTier = "";
			resetModeFlags();
			continue;
		}

		if (isCarrierName(firstCell)) continue;

		// ── Smoker ──
		if (isSmokerKey(firstCell)) {
			currentSmoker = firstCell.toLowerCase();
			currentPayFreq = "";
			currentVolume = "";
			currentTier = "";
			resetModeFlags();
			continue;
		}

		// ── FIX 1: Pay Frequency ──
		// Reset currentVolume and currentTier so volume labels in the new
		// frequency block correctly pass the currentTier === "" guard.
		if (isPayFrequency(firstCell)) {
			currentPayFreq = firstCell.toUpperCase();
			currentVolume = "";
			currentTier = "";
			resetModeFlags();
			continue;
		}

		// ── Tier ──
		if (isTier(firstCell)) {
			currentTier = firstCell;
			resetModeFlags();
			continue;
		}

		// ── Mode A trigger: "Age Band" header row ──
		// if (firstCell.toLowerCase() === "age band" || firstCell.toLowerCase() === "age") {
		// 	ageBandFreqCols = [];
		// 	row.slice(1).forEach((cell, idx) => {
		// 		const c = cell.trim();
		// 		if (c !== "") {
		// 			ageBandFreqCols.push({ freq: c, colIndex: idx + 1 });
		// 		}
		// 	});
		// 	awaitingAgeBandRows = true;
		// 	awaitingBenefitRows = false;
		// 	benefitFreqCols = [];
		// 	continue;
		// }
		// ── Mode A trigger: "Age Band" header row ──
		if (firstCell.toLowerCase() === "age band" || firstCell.toLowerCase() === "age") {
			ageBandFreqCols = [];

			// Try to read freq columns from this row (multi-freq layout)
			row.slice(1).forEach((cell, idx) => {
				const c = cell.trim();
				if (c !== "") {
					ageBandFreqCols.push({ freq: c, colIndex: idx + 1 });
				}
			});

			// ✅ FIX: If no freq columns on this row, use currentPayFreq at col 1
			// This handles: WEEKLY → Tier → Age Band → data (your layout)
			if (ageBandFreqCols.length === 0 && currentPayFreq) {
				ageBandFreqCols.push({ freq: currentPayFreq, colIndex: 1 });
			}

			awaitingAgeBandRows = true;
			awaitingBenefitRows = false;
			benefitFreqCols = [];
			continue;
		}

		// ── Mode B trigger: "benefit amount" header row ──
		if (isBenefitAmountHeader(firstCell)) {
			benefitFreqCols = [];
			row.slice(1).forEach((cell, idx) => {
				const c = cell.trim();
				if (isPayFrequency(c)) {
					benefitFreqCols.push({ freq: c.toUpperCase(), colIndex: idx + 1 });
				}
			});
			awaitingBenefitRows = true;
			awaitingAgeBandRows = false;
			ageBandFreqCols = [];
			continue;
		}

		if (awaitingAgeBandRows && firstCell !== "" && ageBandFreqCols.length > 0 && /\d/.test(firstCell)) {
			const ageBand = firstCell;

			ageBandFreqCols.forEach(({ freq: colHeader, colIndex }) => {
				const rawValue = row[colIndex]?.trim();
				if (!rawValue) return;
				const numValue = parseFloat(rawValue);
				if (isNaN(numValue)) return;

				const path: string[] = [];
				if (currentSmoker) path.push(currentSmoker);
				if (currentVolume) path.push(currentVolume);
				path.push(ageBand);
				if (currentTier) path.push(currentTier);

				if (isPayFrequency(colHeader)) {
					path.push(colHeader.toUpperCase());
				} else {
					path.push(colHeader);
					if (currentPayFreq) path.push(currentPayFreq);
				}

				setDeepValue(result, path, numValue);
			});
			continue;
		}

		// ── Mode B data row ──
		if (awaitingBenefitRows && firstCell !== "" && isNumeric(firstCell) && benefitFreqCols.length > 0) {
			const benefit = firstCell;

			benefitFreqCols.forEach(({ freq, colIndex }) => {
				const rawValue = row[colIndex]?.trim();
				if (!rawValue) return;
				const numValue = parseFloat(rawValue);
				if (isNaN(numValue)) return;

				const path: string[] = [];
				if (currentSmoker) path.push(currentSmoker);
				if (currentVolume) path.push(currentVolume);
				if (currentTier) path.push(currentTier);
				path.push(benefit, freq);

				setDeepValue(result, path, numValue);
			});
			continue;
		}

		// ── Volume label: non-structural, non-numeric text before any tier ──
		if (firstCell !== "" && !isStructuralKeyword(firstCell) && !isNumeric(firstCell) && currentTier === "") {
			currentVolume = firstCell;
			resetModeFlags();
			continue;
		}
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// SHARED UTILITY — write a value at a deep path
// ─────────────────────────────────────────────────────────────────────────────
function roundTo2(value: number): number {
	return Math.round((value + Number.EPSILON) * 100) / 100;
}
function setDeepValue(obj: PremiumTable, path: string[], value: number): void {
	let node = obj;
	for (let d = 0; d < path.length - 1; d++) {
		if (!node[path[d]]) node[path[d]] = {};
		node = node[path[d]];
	}
	node[path[path.length - 1]] = roundTo2(value);
}

// ─────────────────────────────────────────────────────────────────────────────
// SHEET ROUTER
// ─────────────────────────────────────────────────────────────────────────────

function parseSheetIntoResult(rows: string[][], result: PremiumTable): void {
	const layout = detectLayout(rows);
	console.log("Detected layout:", layout);

	switch (layout) {
		case "flat_table":
			parseFlatTable(rows, result);
			break;
		case "multi_benefit_table":
			parseMultiBenefitTable(rows, result);
			break;
		case "volume_tier_benefit":
			parseVolumeTierBenefit(rows, result);
			break;
		case "age_band_tier_benefit": // ← add this
			parseAgeBandTierBenefit(rows, result);
			break;
		default:
			parseNestedSheet(rows, result);
			break;
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// MAIN ENTRY — parse all sheets, store each under its sheet name
// ─────────────────────────────────────────────────────────────────────────────

// export function parseCSVSheetsToJSON(csvText: string): PremiumTable {
// 	const result: PremiumTable = {};

// 	const headerRegex = /SHEET\s+\d+:\s*(\S+)/gi;
// 	const headers: { name: string; contentStart: number; headerStart: number }[] = [];
// 	let match: RegExpExecArray | null;

// 	while ((match = headerRegex.exec(csvText)) !== null) {
// 		headers.push({
// 			name: match[1],
// 			headerStart: match.index,
// 			contentStart: match.index + match[0].length
// 		});
// 	}

// 	for (let i = 0; i < headers.length; i++) {
// 		const { name, contentStart } = headers[i];
// 		const contentEnd = i + 1 < headers.length ? headers[i + 1].headerStart : csvText.length;
// 		const block = csvText.slice(contentStart, contentEnd);

// 		const rows = block.split("\n").map((line) => line.split(",").map((cell) => cell.trim()));

// 		const sheetResult: PremiumTable = {};
// 		parseSheetIntoResult(rows, sheetResult);
// 		console.log("this is the sheet result", sheetResult);

// 		if (result[name]) {
// 			deepMerge(result[name], sheetResult);
// 		} else {
// 			result[name] = sheetResult;
// 		}
// 	}

// 	console.log("Final parsed JSON:", JSON.stringify(result, null, 2));
// 	return result;
// }

export function parseCSVSheetsToJSON(csvText: string): PremiumTable {
	const result: PremiumTable = {
		standard_premium: {} // ← all non-rider sheets go here
	};

	const headerRegex = /SHEET\s+\d+:\s*(\S+)/gi;
	const headers: { name: string; contentStart: number; headerStart: number }[] = [];
	let match: RegExpExecArray | null;

	while ((match = headerRegex.exec(csvText)) !== null) {
		headers.push({
			name: match[1],
			headerStart: match.index,
			contentStart: match.index + match[0].length
		});
	}

	for (let i = 0; i < headers.length; i++) {
		const { name, contentStart } = headers[i];
		const contentEnd = i + 1 < headers.length ? headers[i + 1].headerStart : csvText.length;
		const block = csvText.slice(contentStart, contentEnd);

		const rows = block.split("\n").map((line) => line.split(",").map((cell) => cell.trim()));

		const sheetResult: PremiumTable = {};
		parseSheetIntoResult(rows, sheetResult);
		console.log("this is the sheet result", sheetResult);

		const isRider = name.toLowerCase().includes("rider"); // ← detect rider sheet by name

		if (isRider) {
			// ── Rider sheets → top level ──────────────────────────────────────
			if (result[name]) {
				deepMerge(result[name], sheetResult);
			} else {
				result[name] = sheetResult;
			}
		} else {
			// ── All other sheets → nested inside standard_premium ─────────────
			if (result["standard_premium"][name]) {
				deepMerge(result["standard_premium"][name], sheetResult);
			} else {
				result["standard_premium"][name] = sheetResult;
			}
		}
	}

	console.log("Final parsed JSON:", JSON.stringify(result, null, 2));
	return result;
}

function resolveTierKey(tier: string): "spouse" | "child" | "spouse_and_child" | null {
	const t = tier.toLowerCase();
	if (t.includes("spouse") && (t.includes("child") || t.includes("children"))) return "spouse_and_child";
	if (t.includes("spouse")) return "spouse";
	if (t.includes("child") || t.includes("children")) return "child";
	return null;
}

function resolveTierBenefitOptions(tier: string, plan: any): number[] | null {
	if (!plan.benefit_amount?.is_present) return null;
	const tierKey = resolveTierKey(tier);
	if (tierKey && plan.benefit_amount[tierKey]?.options?.length) return plan.benefit_amount[tierKey].options;
	if (plan.benefit_amount.options?.length) return plan.benefit_amount.options;
	return null;
}

function resolveTierAgeBands(tier: string, plan: any): string[] | null {
	const tierKey = resolveTierKey(tier);
	if (tierKey) {
		const tierAC = plan.benefit_amount?.[tierKey]?.age_criteria;
		if (tierAC?.use_age_bands && tierAC.age_band_ranges?.length) return tierAC.age_band_ranges;
		if (tierAC?.use_specific_ages && tierAC.specific_age_list?.length) return tierAC.specific_age_list.map(String);
	}
	const ac = plan.age_criteria;
	if (!ac) return null;
	if (ac.use_age_bands && ac.age_band_ranges?.length) return ac.age_band_ranges;
	if (ac.use_specific_ages && ac.specific_age_list?.length) return ac.specific_age_list.map(String);
	return null;
}

function setDeep(obj: PremiumTable, keys: string[], value: any): void {
	let cur = obj;
	for (let i = 0; i < keys.length - 1; i++) {
		if (!cur[keys[i]]) cur[keys[i]] = {};
		cur = cur[keys[i]];
	}
	cur[keys[keys.length - 1]] = value;
}

export function buildPremiumStructure(plan: any): PremiumTable {
	const result: PremiumTable = {};
	if (!plan) return result;

	const coverageTiers =
		plan.coverage_for?.is_present && plan.coverage_for?.options?.length ? plan.coverage_for.options : [];
	if (!coverageTiers.length) return result;

	const smokerKeys: string[] = plan.is_premium_depends_on_smoke ? ["smoker", "non_smoker"] : [];

	const payFreqs: string[] =
		plan.pay_frequency?.is_present && plan.pay_frequency?.options?.length ? plan.pay_frequency.options : [];

	const volumes: string[] =
		plan.coverage_volume?.is_present && plan.coverage_volume?.options?.length ? plan.coverage_volume.options : [];

	const smokerDim = smokerKeys.length ? smokerKeys : [""];
	const volumeDim = volumes.length ? volumes : [""];

	for (const smoker of smokerDim) {
		for (const volume of volumeDim) {
			for (const tier of coverageTiers) {
				const ageBands = resolveTierAgeBands(tier, plan);
				const benefitOptions = resolveTierBenefitOptions(tier, plan);

				const prefix: string[] = [];
				if (smoker) prefix.push(smoker);
				if (volume) prefix.push(volume);

				if (ageBands?.length) {
					if (benefitOptions?.length) {
						for (const age of ageBands) {
							for (const ben of benefitOptions) {
								if (payFreqs.length) {
									for (const freq of payFreqs) {
										setDeep(result, [...prefix, age, tier, String(ben), freq], 0);
									}
								} else {
									setDeep(result, [...prefix, age, tier, String(ben)], 0);
								}
							}
						}
					} else {
						for (const age of ageBands) {
							if (payFreqs.length) {
								for (const freq of payFreqs) {
									setDeep(result, [...prefix, age, tier, freq], 0);
								}
							} else {
								setDeep(result, [...prefix, age, tier], 0);
							}
						}
					}
				} else {
					if (benefitOptions?.length) {
						for (const ben of benefitOptions) {
							if (payFreqs.length) {
								for (const freq of payFreqs) {
									setDeep(result, [...prefix, tier, String(ben), freq], 0);
								}
							} else {
								setDeep(result, [...prefix, tier, String(ben)], 0);
							}
						}
					} else {
						if (payFreqs.length) {
							for (const freq of payFreqs) {
								setDeep(result, [...prefix, tier, freq], 0);
							}
						} else {
							setDeep(result, [...prefix, tier], 0);
						}
					}
				}
			}
		}
	}

	console.log("Premium structure:", JSON.stringify(result, null, 2));
	return result;
}
